/**
 * 所有接口变量都以 api开头，例如：apiGetUserInfo
 */
 import { apiDelete, apiGet, apiPost, apiPut } from 'utils'
 import { IAddEditRoleRequest, IMenuListRequest, IRoleItem, IRoleListRequest, ITreeItem } from 'model'
 import { IdList, XhhyBaseType, PaginationResponse, XhhyResponse } from 'Xhhy-common/common'
  
  /**
   * 获取角色列表
   * @param params
   */
  export const apiRoleList = async (params: IRoleListRequest) => {
   return await apiPost<IRoleListRequest, PaginationResponse<IRoleItem>>(`/apppocapi/role/list`, params)
  }
 
  /**
   * 新建角色
   * @param params
   */
   export const apiAddRole = async (params: IAddEditRoleRequest) => {
     return await apiPost<IAddEditRoleRequest, XhhyResponse>(`/apppocapi/role/save`, params)
   }

   /**
   *  修改角色
   * @param params
   */
    export const apiEditRole = async (params: IAddEditRoleRequest) => {
      return await apiPost<IAddEditRoleRequest, XhhyResponse>(`/apppocapi/role/update`, params)
    }
 
   /**
   * 删除角色
   * @param params
   */
    export const apiDeleteRole = async (params: IdList) => {
     return await apiPost<IdList, XhhyResponse>(`/apppocapi/role/delete`, params)
   }

   /**
   * 获取菜单树
   * @param params
   */
    export const apiMenuList = async (params: IMenuListRequest) => {
      return await apiPost<IMenuListRequest, Array<ITreeItem>>(`/apppocapi/menu/init`, params)
    }

 
  